<template lang="pug">
.Login
  .Login-bg
  .Login-window
    .Login-header
      p
        b РСОО
      p Редактор схем обращения с отходами
    form.LoginForm.Clearfix(
      v-if='loginType === "default"',
      @submit.prevent='login'
    )
      .LoginForm-error(v-if='error') {{ error }}
      .LoginForm-item
        input#id_username(
          placeholder='Введите логин',
          v-model='username',
          name='username',
          type='username'
        )
      .LoginForm-item
        input#id_password(
          placeholder='Введите пароль',
          v-model='password',
          type='password',
          name='password'
        )
      .LoginForm-item.LoginSubmit
        .LoginSubmit-buttons
          .LoginSubmit-button
            button.Button.Button-alt(
              type='button',
              @click='continueAsGuest'
            )
              | Продолжить как гость
          .LoginSubmit-button
            button.Button(type='submit')
              | Войти
        .LoginSubmit-register-close-message
          | Регистрация закрыта. Обратитесь к администратору системы.
      //.Clearfix
        button.Button.green.w100p.ff-oseb.small.bor-rnd-5.fs-medium.white-text(@click="changeLoginType('esia')")
          | Использовать для входа ЕСИА
    //.Clearfix.Login-esia.LoginEsia(v-if="loginType === 'esia'")
      .LoginEsia-main
        p Для пользования системой, необходимо идентифицировать себя.
        p
          b Для этого в Системе используется ЕСИА (Госуслуги.ру).
        p
          img(alt='Госуслуги', src='../assets/gosuslugi_logo.svg')
        p
          | Вы должны быть добавлены в ЕСИА в перечень сотрудников той организации, от имени которой вы планируете работать в Системе. Для добавления и получения соответствующих прав доступа вы можете обратиться к администратору профиля ЕСИА вашей организации.
      .LoginEsia-footer.Clearfix
        button.Button(@click='redirectToEsia') Войти через ЕСИА
        button.Button(@click="changeLoginType('default')") Войти, используя логин и пароль
</template>

<script>
export default {
  name: 'Login',

  data() {
    return {
      username: null,
      password: null,
      error: '',
      loginType: 'default'
    }
  },

  methods: {
    login() {
      this.error = ''
      this.$store
        .dispatch('getToken', {
          username: this.username,
          password: this.password
        })
        .then(() => {
          this.$router.replace('objects')
        })
        .catch(() => {
          this.error = 'Ошибка авторизации'
        })
    },

    changeLoginType(type) {
      this.loginType = type
    },

    redirectToEsia() {
      alert('Redirect to ESIA will be here')
    },

    continueAsGuest() {
      this.$emit('continueAsGuest')
    }
  }
}
</script>

<style scoped lang="scss">
.LoginEsia {
  background: #fff;
  font-size: 14px;
  line-height: 21px;
  color: #6a728c;

  p {
    margin: 15px 0;

    &:first-child {
      margin-top: 0;
    }
  }

  &-footer {
    .Button {
      margin-bottom: 15px;
    }
  }
}
.LoginSubmit {
  &-buttons {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &-button {
    flex: 0 0 auto;
  }

  &-register-close-message {
    padding: 12px 0 0 0;
    text-align: center;
    font-size: 12px;
  }
}
.LoginForm {
  input {
    width: 100%;
    height: 32px;
    border: none;
    padding: 0 10px;
    color: #191919;
    outline: none;
    font-size: 13px;
    font-weight: normal;
    border-radius: 4px;
    font-family: 'Exo 2', sans-serif;
    background: #eee;
  }

  input:focus,
  input:hover {
    border: 1px solid #ccc;
    color: #077498;
    background: #fff;
  }

  &-error {
    padding: 0 15px 15px;
    font-size: 14px;
    color: red;
  }
  &-item {
    position: relative;
    margin-bottom: 15px;
    line-height: 16px;
  }
}
.Login {
  &-bg {
    width: 100%;
    height: 100%;
    opacity: 0.4;
    position: absolute;
    left: 0;
    top: 0;
    //background: url(../assets/modelwaste_background.png);
    background: #fff;
  }

  form {
    padding: 15px;
    background: #fff;
  }

  * {
    box-sizing: border-box;
  }

  a {
    text-decoration: none;
  }

  &-window {
    background: #5490c3;
    border-radius: 5px !important;
    text-align: center;
    font-family: 'Exo 2', sans-serif;
    border: 5px solid #5490c3;
    position: fixed;
    width: 380px;
    left: 50%;
    margin-left: -190px;
    height: auto;
    top: 50%;
    overflow-y: auto;
    transform: translateY(-50%);
  }

  &-header {
    font-family: 'Exo 2', sans-serif;
    padding: 15px;
    background-color: #5490c3;
    color: #fff;
    font-size: 16px;

    b {
      font-size: 28px;
    }

    p:last-child {
      margin-bottom: 0;
    }

    p:first-child {
      margin-top: 0;
    }
  }

  &-esia {
    padding: 15px;
  }

  .Button:hover,
  .btn:hover {
    opacity: 1;
    -webkit-box-shadow: inset 0 1px 3px #000;
    box-shadow: inset 0 1px 3px #000;
  }

  .Button:not(:disabled),
  [type='button']:not(:disabled),
  [type='reset']:not(:disabled),
  [type='submit']:not(:disabled) {
    cursor: pointer;
  }

  .Button {
    position: relative;
    padding: 0 0.5rem;
    border: none;
    border-radius: 2px;
    text-align: center;
    text-decoration: none;
    text-overflow: ellipsis;
    white-space: nowrap;
    outline: 0;
    cursor: pointer;
    display: inline-block;
    -webkit-transition: all 75ms linear;
    transition: all 75ms linear;
    opacity: 1;
    line-height: 32px;
    height: 32px;
    font-size: 14px;
    font-family: 'Lato', sans-serif;
    color: #fff;
    background: #5490c3;
    width: 100%;

    &:hover {
      box-shadow: none;
      background-color: rgba(#5490c3, 0.5);
    }

    &-alt {
      background-color: transparent;
      color: #5490c3;

      &:hover {
        box-shadow: none;
        background-color: rgba(#5490c3, 0.5);
        color: #fff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Login.vue